import React from 'react';
import { Link } from 'react-router-dom';
import { Card, Typography, Button, Image, Grid, Divider } from 'antd';
import '../../../Styles/Linkages&Outreach.css';
import image from "../../../Assets/Linkages/Capacity-Building-Workshops-AI.png"

const { Title, Paragraph } = Typography;
const { useBreakpoint } = Grid;


const TrainingWorkshops = () => {
  const screens = useBreakpoint();

  return (
    <div className="training-workshops-container">
      <Card className="training-workshops-card" bordered={false} bodyStyle={{ padding: '40px' }}>
        <div className="content-wrapper">
          <div className="image-section">
            <Image
              preview={false}
              src={image}
              alt="Space and geospatial technology training laboratory and forum"
              className="program-image"
            />
          </div>
          <div className="text-section">
            <Title level={2} className="section-title">
Capacity Building Workshops & Forums
            </Title>
            <Divider className="ncgsa-divider" />
            <Paragraph style={{
            fontSize: screens.xs ? '14px' : screens.sm ? '20px' : screens.lg ? '125px' : '25px',
            lineHeight: screens.xs ? '1.5' : '1.8',
            textAlign: 'justify',
            color: 'black' // Optional: custom color
          }} className="description">

An integrated framework of advanced trainings and hands-on workshops is offered to strengthen national capacity in the domains of space science, geospatial technologies, and allied disciplines. These professionally curated learning experiences are aimed at cultivating practical skills and applied knowledge among a diverse participant base including students, early-career professionals, researchers, educators, industry leaders, and policy stakeholders. Each program is designed with a strong emphasis on real-world application, state-of-the-art tools, and emerging technologies, ensuring relevance to both current challenges and future demands of the space sector.           </Paragraph>
            <Link to="/capacity-building-workshops-forums">
              <Button className="view-all-btn" type="primary" shape="round">
                View All
              </Button>
            </Link>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default TrainingWorkshops;
